var _ = require('underscore'),
    ScaleModel = require('./../models/scale'),
    Util = require('../../FV/util');

/*
* Pre-Making of the state change
* Context is state -- added to the commands of the vChannel, 'autofowarded from channel'
* need instance -- use constructor
* */

module.exports = function() {

    _.extend( this, { commands: {
        /*
        * Entry point for activeNote change --
        * Will spur mode and/or page change logic after when appropriate.
        * Handles document locking/unlocking.
        * */
        setActiveNote: function( note, options ) {

            var entering = note;

            if ( entering ) {

                if ( !note.isPageNote() ) {
                    setActiveActiveNote.call(this);
                    return;
                }

                // Page Note
                if ( options.createNote || options.isEdit ) { // wouldn't this always be true?

                    /*
                     * LockSuccessCB: Set a flag that the document is locked for entering page note editing.
                     * Facilitates checking the need to clear the lock on exit of edit mode, and clearer than checking
                     * various options that would lead to need to unlock the document. ( eg: options.noteSaved )
                     * Can also be picked up on to clear the locks on actions like window unload and session timeout.
                     * Note: doesn't hurt to call lock again if in find and redact mode ...
                     * */
                    this.command( 'lockActiveDocument', 'PG_NOTE_EDITING', options.createNote ? 'Create Note' : 'Edit Note', _.bind(function() {

                        if ( note.isDrawable() ) {

                            // Here is where we need to 'wait' ....
                            // Could create pageMode view twice ...
                            if ( this.viewMode() !== 'page') {
                                this.setViewMode('page'); // maybe with option not to do the canvas?
                            }

                            if ( !note.isNew() && note.pageNumber !== this.currentPageNumber() ) {
                                this.goToPageOfNote(note); // maybe just make setting rendering the currentPageMode page empty here ... or put in a callback as an option to set the activeNote
                            }

                        }

                        setActiveActiveNote.call(this);

                    }, this));
                }


            } else {


                // Exiting: note param will be undefined so get from state before we set it back.
                // Only unlock the document if the note being edited came from a note that was locked; easier than checking conditions to get in here --
                // latter I don't understand anymore
                var exitingNote = this.request('activeNote');

                if ( !exitingNote.isPageNote() || !this.getDocumentLockState().isLockedByPageNoteEditing() ) {
                    setActiveActiveNote.call( this );
                    return;
                }


                // For status messages/errors, the below will show warnings, not alerts until multiple alert dialogs supported (DVBC-1572).

                this.command( 'unlockActiveDocument', 'PG_NOTE_EDITING', 0, this, function() {

                    setActiveActiveNote.call(this);

                });

            }



            // The active note part:
            // - currently not using a callback/deferred to run after page &/or mode change
            // - in those scenarios, the canvas (and page) will always be rendered in active/expanded 'mode' on
            // - page image load, so if this called before the canvas/page is ready, we don't have a problem.
            function setActiveActiveNote() {

                if (entering) {

                    if ( note.isDrawable() ) {

                        // Don't trigger activeNoteSubType; more cleanup necessary see graphicNoteShape toolbar code ( could be set twice in this workflow)
                        // Perhaps store on the noteUI model and listen from there
                        this.set( 'activeNoteSubType', note.getDefaultShapeSubType(), {silent: true} );

                    }

                    this.set({ activeNote: note } , options );

                } else {

                    this.set( {activeNoteSubType: null}, {silent: true} );

                    this.set( {activeNote: null }, options );

                }

            }


        },

        /**
         * API calls of mode, page called here before the expanded note
         * If drawable and entering, go to approp. mode and pg before triggering canvas.
         * Note: if changing mode / page the expanded note event may not yet be ready --
         * when those are called the canvas may not yet be ready to pick up the change event ... however,
         * onRender on the canvas the expanded note is incorporated, so we don't need to worry about race conditions.
         * An alternative would be setting a canvasOnLoad event 'flag' from the bottom up -- it's an async process,
         * and then setting the notes as a callback.
         */
        setExpandedNote: function(note) {

            // ( Only drawable notes allow expanding )
            var enteringAndDrawable = note && note.isDrawable(),
                notInPgMode = this.viewMode() !== 'page';

            enteringAndDrawable && notInPgMode && this.setViewMode('page');

            enteringAndDrawable && ( note.pageNumber !== this.currentPageNumber() ) &&
                this.goToPageOfNote(note);

            this.set('expandedNote', note);

        },

        setViewMode: function(mode) {

            var activeNote = this.activeNote();

            if ( !activeNote || !activeNote.isDrawable() ) {
                this.set('viewMode', mode);
                return;
            }


            this.trigger('modal:open', {
                confirmType: 'warning',
                title: 'Confirm',
                content: 'Change view mode without saving note?',
                okCB: _.bind(function () {

                    // Clean up the active note prior to changing the mode -- give same options as cancelling from the note module
                    // Nothing sync about exiting
                    this.setActiveNote( null, {
                        userCancelled: true,
                        isEdit: !activeNote.isNew()
                    });

                    this.set({
                        viewMode: mode
                    });

                }, this)

            });


        },
        goToPage: function(page, options) {

            var activeNote = this.activeNote();

            if ( !activeNote || !activeNote.isDrawable() ) {
                this.set({currentPage: page}, options);
                return;
            }

              //if in drawing mode, alert user prior to changing page that notes will be deleted
            this.trigger('modal:open', {
                confirmType: 'warning',
                title: 'Confirm',
                content: 'Change page without saving note?',
                okCB: _.bind( function() {

                    // Destroying the canvas first should be sync and fine
                    // ( Same as mode change with an active note open )
                    this.setActiveNote( null, {
                        userCancelled: true,
                        isEdit: !activeNote.isNew()
                    });

                    this.set({
                        currentPage: page
                    }, {
                        isEdit: activeNote && !activeNote.isNew() // can probably rid this
                    });

                }, this),
                actionBtn: 'Yes',
                cancelBtn:  'No'
            });

        },
        goNextPage: function () { //nav command and api
            var nextPage = this.nextPage();
            nextPage && this.goToPage(nextPage);
        },
        goPrevPage: function () {
            var prevPage = this.prevPage();
            prevPage && this.goToPage(prevPage);
        },
        goToFirstPage: function () {
            var firstPage = this.vChannel.request('activeDocPages').first(); //todo: first page fn
            firstPage && this.goToPage(firstPage);
        },
        goToLastPage: function () {
            var lastPage = this.vChannel.request('activeDocPages').last();
            lastPage && this.goToPage(lastPage);
        },
        goToPageOfNote: function(note) {
            this.goToPage( note.getPageModel() );
        },
        goToPageId: function(pageId) {

            var page =
                this.vChannel.request('activeDocPages').findWhere({ pageId: pageId });

            page && this.goToPage(page);

        },


        /**
         * * SCALE: the first time, must set scale to calc the value immediately after scale created
         *  -- call must go through here, not scale model
         *  All see listenToScaleEvents -- want ignored initially
         */

        setInitialScale: function( which, defaultScale, cssConstants, viewModeEls ) {

            var scaleModel = new ScaleModel({
                scale: defaultScale,
                DEFAULT_SCALE: defaultScale,
                mode: which,
                V_PADDING: cssConstants.V_PADDING || 0, // temp until read css from markup
                H_PADDING: cssConstants.H_PADDING || 0,
                outerDiv: viewModeEls.outerDiv
            });

            this.set( which + 'ViewScale', scaleModel );

            var pageForScale = which === 'document'
                ? this.currentPage()
                : this.fullPageModel();

            scaleModel.setScale( pageForScale );

            return scaleModel;

        },

        /**
         * Set the scale of the current mode (CENTRAL ENTRY POINT)
         * TODO: except in above, FS MODE TOGGLE CB, reset of size of gos renderable, and layout pane open/close)
         * above old comment similar to issue is DVBC-1408
         * In many ways acts like an 'update viewport' now for doc and page mode containers
         */
        setScale: function() {

            var scaleModel = this.getCurrentScaleModel(),
                viewMode = this.viewMode(),
                pdfMode = !scaleModel;

            if ( pdfMode || this.vChannel.request('activeDocPages').length < 1 ) //TODO: cache/optimize has pages
                return false;

            var pg = viewMode === 'document' ? this.currentPage() : this.fullPageModel(),
                args = Array.prototype.slice.apply(arguments); // TODO: cache

            args.unshift(pg);
            scaleModel.setScale.apply(scaleModel, args); //slowest if custom args, could optimize


        },

        zoomIn: function () {
            if  (this.get('paneIsCoveringLayout'))
                return false;
            var newScale = parseFloat(this.getCurrentScaleValue() + this.vChannel.request('zoomIncrement')).toFixed(2);
            newScale = Math.ceil(newScale * 10) / 10; //make it pretty
            this.setScale(newScale, 'custom');
        },
        zoomOut: function () {
            var MIN_SCALE = this.vChannel.request('minScale');
            if  (this.get('paneIsCoveringLayout'))
                return false;
            var newScale = parseFloat(this.getCurrentScaleValue() - this.vChannel.request('zoomIncrement')).toFixed(2);
            newScale = Math.floor(newScale * 10) / 10; //make it pretty
            if (newScale < MIN_SCALE)  newScale = MIN_SCALE; //don't allow below 25%
            this.setScale(newScale, 'custom');
        },
        /* decrease by one after image loads -- todo: queue */
        updateImgsLoadingDocMode: function(options) {
            var d = options.increase ? 1 : -1;
            this.set('numberImagesLoadingInDocMode', this.numberImagesLoadingInDocMode()+ d );
        },
        toggleFullScreenMode: function() {
            this.toggle('fullScreenMode');
        },
        setPDFisLoaded: function() {
            this.set('pdfRendered', true);
        },
        setViewerLoaded: function() {
            this.set('viewerLoaded', true);
        },
        setPanelIsResizing: function(val) {
            this.set('panelIsResizing', val);
        },


        /*
         * *** Central point to lock the document -- all calls must come through here ***
         * Same WF as vChannel.checkActiveDocLockStatus, though obtain the lock without checking first.
         * If unsuccessful the document was already locked by another user.
         * lockSource ( required ):
         * - docLockState.lockSource ( use to resolve 'conflicts' locking and unlocking
         *      -- eg if locked by PG_NOTE_EDITING and then FIND_AND_REDACT )
         * - added to docLockState.lockSource after successful web service call
         * - also added if document is already locked by another source; here we don't we to call the web-service again
         * action: required -- Action name used in error dialogs
         * lockSuccessCB: required -- fn to proceed if document successfully locked in db call
         * docLockedByOtherUserCB: optional -- fn to call if the document was locked by another user. Default is showing an alert (prevent the action).
         * errorCB: optional -- function to call if error occurs hitting the endpoint.  Default is showing an alert (prevent the action).
         * */
        lockActiveDocument: function( lockSource, action, lockSuccessCB, docLockedByOtherUserCB, errorCB ) {

            // First check any cases where we wouldn't want call the webservice:
            // exit with a lockSuccessCB to continue without a docLockResponse parameter.
            var docLockState = this.request('getDocumentLockState');

            // If for some reason, we're locked by lockSource, don't lock again
            // ( eg, 're-search from Find and Redact' )
            if ( docLockState.isLockedBySource( lockSource ) ) {
                lockSuccessCB.call( this );
                return;

            }

            // Add lockSource without calling the webservice if document is already locked by another source
            if ( docLockState.isLockedByOtherSource( lockSource )  ) {
                docLockState.addLockSource( lockSource );
                lockSuccessCB.call( this );
                return;
            }

            // Document is unlocked: make the call and if successful, add the lockSource to docLockState

            var shortErrMsg = 'Cannot ' + Util.toTitleCase(action);

            this.request('activeDocument').lock( this )
                .done( function( docLockResponse ) {

                    // Successful lock -- proceed
                    if ( docLockResponse.getSuccess() ) {

                        docLockState.addLockSource( lockSource );

                        lockSuccessCB.call( this, docLockResponse );

                    }
                    // Failure: someone else has the document locked
                    else {
                        docLockedByOtherUserCB
                            ? docLockedByOtherUserCB.call(this, docLockResponse)
                            : this.command( 'showDocumentLockedErrorAlert', shortErrMsg, docLockResponse );
                    }

                })
                .fail( function( jqXHR ) {
                    errorCB
                        ? errorCB.call(this, jqXHR)
                        : this.command('ajaxError', jqXHR, shortErrMsg );
                });

        },


        /*
         * *** Central point to unlock the document -- ** all calls must come through here ***
         * Wrapper around unlocking the document with common defaults to perform,
         * assuming we don't want to really show success/failure messages prominently to the user:
         * write msg's via console.info on success and console.warn msg's on unsuccessful/failure.
         * All parameters optional expect lockSource ( docLockState.lockSource ) and alwaysCB
         * - like lockDocument, if there are any conflicts, exit with the alwaysCB callback ( maybe change to success to match lock command )
         * - if performed, the state's lockSource is unset on a successful call
         * Utilize the alwaysCB for an action to take place afterwards on success/error ( jqXHR callbacks are run in the order they are defined ).
         * Now called from exit active note change, was to be called on viewer.destroy (DVBC-1581).
         * */
        unlockActiveDocument: function( lockSource, force, cxt, alwaysCB, unlockSuccessCB, docLockedByOtherUserCB, errorCB ) {

            // First check any cases where we wouldn't want to call the web service to unlock the document;
            // If so, exit with an alwaysCB to continue ( without a docLockResponse parameter ).

            var docLockState = this.request('getDocumentLockState');

            // Don't unlock if already unlocked -- just in case -- it's not necessary ( no src's would be set )
            if ( docLockState.isNotLocked() ) {
                alwaysCB.call( cxt );
                return;
            }

            // If locked by another source, remove this source without unlocking the document.
            if ( docLockState.isLockedByOtherSource( lockSource ) ) {

                docLockState.removeLockSource( lockSource );
                alwaysCB.call(cxt);
                return;
            }

            // Make the call and if successful, set lockSource to docLockState ( can change isLocked ).

            force = force || 0;
            cxt = cxt || this;

            this.request('activeDocument').unlock( force, cxt )
                .done( function( docLockResp ) {

                    if ( docLockResp.getSuccess() ) {

                        docLockState.removeLockSource( lockSource );

                        unlockSuccessCB
                            ? unlockSuccessCB.call( cxt, docLockResp )
                            : console.info( 'Document ' + docLockResp.getDocId() + ' unlocked.' );

                    } else {

                        docLockedByOtherUserCB
                            ? docLockedByOtherUserCB.call( cxt, docLockResp )
                            : console.warn( 'Unable to unlock document. ' + docLockResp.getDefaultErrorMessage() );

                    }

                })
                .fail( function( jqXHR ) {
                    errorCB
                        ? errorCB
                        : console.warn( 'Unable to unlock document. ' +  $.fn.ajaxErrorMessage(jqXHR) );

                })
                .always( function( docLockResp ) {
                    if (alwaysCB)
                        alwaysCB.call( cxt, docLockResp );

                });

        },


        // TODO: now disabled, not in use ...
        toggleShowPageTextMode: function() {
            this.toggle( 'showPageTextMode' );
        },

        toggleTextOnlyMode: function() {

            //console.log( 'toggleTextOnlyMode' );

            // must show the text, do this first here; do first and by force
            //this.set( 'showPageTextMode', null, {silent: true} );
            //this.set( 'showPageTextMode', true );

            this.toggle( 'showPageTextMode' );

            this.toggle( 'textOnlyMode' );
        }

    }});

    /* single point of access for the prop's -- note: sometimes properties them */
    _.extend(this, { requests: {
        currentPage: function () {
            return this.get('currentPage');
        },
        currentPageNumber: function () {     //return the current page or null if no pages in document
            var curPg = this.currentPage(); //here in case no pgs in doc
            return curPg ? curPg.get('number') : null;
        },
        nextPage: function(pg) {
            var currentPg = pg || this.currentPage(),
                pages = this.vChannel.request('activeDocPages'),
                currengPgIndex = pages.indexOf(currentPg);
            return (currengPgIndex < pages.length) ? pages.at(currengPgIndex + 1) : null; //return null if last page
        },
        prevPage: function(pg) {
            var currentPg = pg || this.currentPage(),
                pages = this.vChannel.request('activeDocPages'),
                currengPgIndex = pages.indexOf(currentPg);
            return (currengPgIndex > 0 ) ? pages.at(currengPgIndex - 1) : null; //return null if first page
        },
        isFirstPage: function () {
            return this.currentPage() === this.vChannel.request('activeDocPages').first();
        },
        isLastPage: function () {
            return this.currentPage() === this.vChannel.request('activeDocPages').last();
        },
        /**
         * Returns wether the current page support annotation.
         * For safety, check to see if document has pages -- if not return false.
         * (Bonus is this avoid another call to check for invoker).
         */
        currentPageSupportsAnnotation: function() {
            var curPg = this.currentPage();
            return curPg ? curPg.supportsAnnotation() : false;
        },

        noteIsActiveOrExpanded: function () {
            var isEditing = this.activeNote(),
                noteExpanded = this.expandedNote(),
                isActiveOrExpanded = isEditing || noteExpanded; //(don't want to return null)
            return isActiveOrExpanded ? true : false;
        },
        noteIsActiveNote: function(note) {
            return note === this.activeNote();
        },
        pgNoteIsOfActivePage: function(note) {
            return note && note.pageNumber === this.currentPageNumber();
        },
        expandedNote: function () {
            return this.get('expandedNote');
        },
        numberImagesLoadingInDocMode: function () {
            return this.get('numberImagesLoadingInDocMode');
        },
        viewMode: function () {
            return this.get('viewMode');
        },

        // TODO: refactor other ref's
        viewModeIsPdf: function() {
            return this.get('viewMode') === 'pdf';
        },

        //added (were accessed directly)
        activeNote: function() {
            return this.get('activeNote');
        },
        activeNoteSubType: function() {
            return this.get('activeNoteSubType');
        },
        viewerLoaded: function() {
            return this.get('viewerLoaded');
        },
        loadImages: function() {
            return this.get('loadImages');
        },
        //wasn't in requests -- should be ???
        fullPageModel: function () {
            return this.get('fullPageModel');
        },
        getCurrentScaleValue: function () {

            if (this.viewMode() === 'pdf')
                return null;

            return this.getCurrentScaleModel().get('scale');

        },
        /* Note: now Doc Mode Scale may not exist -- but shouldn't be in Doc Mode if that's the case */
        getCurrentScaleModel: function () {

            var viewMode = this.viewMode();

            // ( Never call from PDF mode )
            if (viewMode === 'pdf')
                return null;

            return this.get( (viewMode === 'document' ? 'document' : 'page') + 'ViewScale' );
        },

        pageViewScale: function() {
            return this.get('pageViewScale');
        },

        /** -- Doc Lock ---- */
        getDocumentLockState: function() {
            return this.get( 'documentLockState' );
        },

        isDocumentLockedByApplication: function() {
            return this.getDocumentLockState().isLocked();
        },


        /** -- Doc Lock */

        paneIsCoveringLayout: function() {
            return this.get('paneIsCoveringLayout');
        },

        /*
         *  Return whether to disable page rotation in the UI given the current state of the UI.
         *  Left on here (rather than vChannel like other page operations b/c of state implications & legacy code).
         * */
        disableRotation: function () {

            var allowRotate = this.request('activeDocument').allowRotatePages() &&
                this.request('currentPage').isRotatable() &&
                !this.paneIsCoveringLayout() &&
                !this.noteIsActiveOrExpanded();

            return !allowRotate;
        },

        // (auto-forward from vChannel request )
        findAndRedactSearchModel: function() {

            return this.get('findAndRedactSearchModel');

        },

        showPageTextMode: function() {
            return this.get('showPageTextMode');
        },

        textOnlyMode: function() {
            return this.get('textOnlyMode');
        },

        previousActiveNote: function() {
            return this.previous('activeNote');

        }

    }});
};




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/state/api.js
 ** module id = 101
 ** module chunks = 0
 **/